import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { VersionSchema } from "@/types";
import { versionToString } from "@/util";
import { deltaApiStore, deltaStore } from "@/hooks";
import { TextButton, PanelCard, SelectInput } from "@/components/common";


/**
 * Displays the delta panel navigation.
 */
const __default__ = {
  name: "DeltaPanelNav",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const deltaVersion = computed({
  get() {
    return deltaStore.afterVersion;
  },
  set(newVersion) {
    deltaApiStore.handleCreate(newVersion);
  },
});

/**
 * Returns a version's name.
 * @param version - The version to name.
 * @return The version's name.
 */
function getVersionName(version: VersionSchema): string {
  return versionToString(version);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    borderless: "",
    title: "Version Delta"
  }, {
    default: _withCtx(() => [
      (deltaVersion.value && !!deltaVersion.value.versionId)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            block: "",
            outlined: "",
            label: "Hide Delta View",
            icon: "cancel",
            class: "q-mb-md",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(deltaApiStore).handleDisable()))
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(SelectInput), {
        modelValue: deltaVersion.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((deltaVersion).value = $event)),
        options: _unref(deltaApiStore).deltaVersions,
        loading: _unref(deltaApiStore).loading,
        "option-value": "versionId",
        "option-label": getVersionName,
        label: "Delta Version",
        hint: "The version to view the delta between."
      }, null, 8, ["modelValue", "options", "loading"])
    ]),
    _: 1
  }))
}
}

})